export const initialState = {
  sublimits: []
};

export const reducer = (state, action) => {
  switch (action.type) {
    case 'OnInitState':
      return onInitState(state, action);
    case 'OnSublimitSaved':
      return onSublimitSaved(state, action);
    case 'OnSublimitHeaderChanged':
      return onSublimitHeaderChanged(state, action);
    case 'OnAddNewSublimit':
      return onAddNewSublimit(state, action);
    case 'OnSublimitDeleted':
      return onSublimitDeleted(state, action);
    case 'BeforeSavingSublimit':
      return beforeSavingSublimit(state, action);

    default:
      return state;
  }
};

const onInitState = (state, action) => {
  const { sublimits } = action;
  return {
    ...state,
    sublimits
  };
};

const onSublimitHeaderChanged = (state, action) => {
  const { property, propertyValue, index } = action;
  return {
    ...state,
    sublimits: Object.assign([...state.sublimits], {
      [index]: {
        ...state.sublimits[index],
        [property]: propertyValue,
        changed: true
      }
    })
  };
};

const onAddNewSublimit = (state, action) => {
  const { facilityId, siteId, defaultSublimitValue } = action;
  const newSublimit = {
    siteId: siteId,
    facilityId: facilityId,
    sublimitValue: defaultSublimitValue,
    changed: false
  };

  return {
    ...state,
    sublimits: [...state.sublimits, newSublimit]
  };
};

const onSublimitSaved = (state, action) => {
  const { index, sublimitId } = action;

  return {
    ...state,
    sublimits: Object.assign([...state.sublimits], {
      [index]: {
        ...state.sublimits[index],
        sublimitId: sublimitId,
        changed: false,
        saving: false
      }
    })
  };
};

const beforeSavingSublimit = (state, action) => {
  const { index } = action;
  return {
    ...state,
    sublimits: Object.assign([...state.sublimits], {
      [index]: {
        ...state.sublimits[index],
        saving: true
      }
    })
  };
};

const onSublimitDeleted = (state, action) => {
  const { index } = action;

  const sublimits = [...state.sublimits];
  sublimits.splice(index, 1);

  return {
    ...state,
    sublimits
  };
};
